import { Button, Card, Col, Flex, Row, Skeleton, message } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { type Template, getTemplatesPaged } from "../../../service/templates.service";
import { setAITemplateModalState, setSelectedView, setStoredTemplateData } from "../../../slices/appStateSlice";
import TemplateCard from "../../TemplateCard/template-card.component";
import styles from "./AITemplateModal.module.scss";
import { ViewType } from "./types";

const TemplateListContainer = () => {
  const component = "ai-template-modal";
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [templates, setTemplates] = React.useState<Template[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    const fetchTemplates = async () => {
      try {
        // Only a 6-card preview is shown; don't download the whole gallery for it.
        const page = await getTemplatesPaged({ page_size: 6 });
        setTemplates(page.results);
      } catch (error) {
        message.error("Failed to load templates");
        console.error("Error fetching templates:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  const handleUseTemplate = (template: Template) => {
    dispatch(
      setStoredTemplateData({
        id: template.id,
        name: template.name,
        document: template.content,
        isFromTemplate: true,
      }),
    );
  };

  const navigateToTemplateGallery = () => {
    dispatch(setAITemplateModalState(false));
    dispatch(setSelectedView(ViewType.TEMPLATE));
    navigate("/templates");
  };

  if (loading) {
    return (
      <Row gutter={[16, 16]} style={{ padding: "20px" }}>
        <Col span={12}>
          <Card>
            <Skeleton active />
          </Card>
        </Col>
        <Col span={12}>
          <Card>
            <Skeleton active />
          </Card>
        </Col>
      </Row>
    );
  }
  return (
    <Flex vertical className={styles[`${component}__template-list`]} gap={16}>
      <Row gutter={[16, 16]}>
        {templates.map((template, index) => (
          <Col span={24} md={12} lg={12} key={template.slug}>
            <TemplateCard
              slug={template.slug}
              title={template.name}
              description={template.description}
              content={template.content}
              index={index}
              onUse={() => handleUseTemplate(template)}
            />
          </Col>
        ))}
      </Row>
      {templates.length > 0 && (
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button onClick={navigateToTemplateGallery}>View All Templates</Button>
          </Col>
        </Row>
      )}
    </Flex>
  );
};

export default TemplateListContainer;
